<template>
    <div>
        <h2 class="text-md-center">Work Experience</h2>
        <Job v-for="job in jobs" :job="job.job" :tech-job="job.techJob" v-bind:key="job.job" :information="job.information"></Job>
    </div>
</template>

<script>
    import Job from "@/components/Job";

    export default {
        name: "Experience",
        components: {
            Job
        },
        data () {
            return {
                jobs: [
                  {
                    job: "Integral Ad Science",
                    information: {
                      year: '2022 - Current',
                      points: [
                        "Channel B's impressions daily via client tech",
                        'Block & monitor on any open web device',
                        'Modernize QA with automated Device Farm',
                        'Track video, display, hover, and click data',
                        'Integrate large clients: Amazon, Disney, etc…',
                        'Implemented MCP, "Skill-as-Code", and Mastra to unify independent AI agents company-wide'
                      ],
                      skills: [
                        "BrowserStack",
                        "Databricks",
                        "JavaScript",
                        "Jenkins",
                        "Model Context Protocol",
                        "Prompt Engineering"
                      ]
                    },
                    techJob: true
                  },
                  {
                    job: "Fifth Third Bank",
                    information: {
                      year: '2020 - 2022',
                      points: [
                        'Manage Online Banking Account System',
                        'Mobile Modernization development',
                      ],
                      skills: [
                        "Terraform",
                        "Docker",
                        "Java",
                      ]
                    },
                    techJob: true
                  },
                    {
                      job: "Ball Aerospace",
                      information: {
                        year: '2020 - 2021',
                        points: [
                          'Pipeline development and automation for Ground Command Control and Communications',
                          'Standardizing Java App Development Process',
                          'Security Clearance'
                        ],
                        skills: [
                          "Terraform",
                          "GitLab",
                          "Docker",
                          "Java",
                          "Python",
                        ]
                      },
                      techJob: true
                    },
                    {
                        job: "GE Aviation Digital",
                        information: {
                            year: '2018 - 2020',
                            points: [
                                'Designed ELK stack supporting 12 sources of continuous data',
                                'Support a "Google like" search for 14+ million documents',
                                'Digital Tiger Team developer supporting 10+ applications',
                                'Security, bug, and feature enchantments to 10+ applications',
                                'Release planning for all applications (~6 teams)'
                            ],
                            skills: [
                                "Elastic Search",
                                "Logstash",
                                "Kibana",
                                "Spring",
                                "JQuery",
                                "Oracle",
                                "Cloudwatch",
                                "EC2",
                                "Beanstalk"
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Kroger Digital",
                        information: {
                            year: '2016 - 2018',
                            points: [
                                'Harness Cassandra and Solr for products, articles, and recipes searching',
                                'Enhance search with synonyms, spelling suggestion, word break, phrasing, and personalization algorithms',
                                'UI maintenance for search',
                                'QA Tester with automated testing',
                                'Rehaul of UI Clicklist checkout',
                                'Experiment Clicklist shopping with Alexa',
                                'Plugin development for Rundeck by incorporating open source solutions',
                                "Rundeck script automation",
                                'User experience analysis with Dynatrace'
                            ],
                            skills: [
                                "Spring",
                                "Elastic Search",
                                "Docker",
                                "Cassandra",
                                "GitLab",
                                "Angular",
                                "PhantomJS",
                                "Alexa Skill",
                                "Heroku",
                                "Dynatrace",
                                "RUNDECK"
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "TATA Consulting Services (Intern)",
                        information: {
                            year: '2016',
                            points: [
                                'Partnered with interns as full stack team',
                                'Create visitor/badge system for building security',
                                'UI Developer'
                            ],
                            skills: [
                                "Angular",
                                "Git"
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Toyota Boshoku America",
                        information: {
                            year: '2015 - 2016',
                            points: [
                                'Explored and revised unsupported Oracle report tool with Excel4apps',
                                'Consolidated and directed Digital Signage of physical and software components'
                            ],
                            skills: [
                                "Oracle"
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Power & Water (Intern)",
                        information: {
                            year: '2015',
                            points: [
                                'Business intelligence analyst for PG IT Team',
                                'Interpreted and modeled data with engineers and finance',
                                'Created visual and interactive data reports with Tableau'
                            ],
                            skills: [
                                "Tableau"
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "GE Corporate (Intern)",
                        information: {
                            year: '2013 - 2014',
                            points: [
                                'Integrated Cloud applications into VDI infrastructure for data simplification',
                                'Interpreted and modeled data with engineers and finance',
                                'Drove data cutback for GE Mobile',
                                'Researched regulations of 1000+ employees’ data usage'
                            ],
                            skills: [
                                "VMWare"
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "The Fence Company",
                        information: {
                            year: '2013',
                            points: [
                                'Social Media Analyst',
                                'Managed 2+ social media accounts',
                                'Introduced new web interfaces/tools',
                                'Compared competitors’ web tactics'
                            ]
                        },
                        techJob: true
                    },
                    {
                        job: "Shudog Services LLC",
                        information: {
                            year: '2007 - 2015',
                            points: [
                                'Founder/CEO of landscaping division',
                                'Hired, trained, and managed 5 employees',
                                'Expanded to a loyal clientele of 25+',
                                'History of approximately 50 clients'
                            ],
                            skills: [
                                "eXmark",
                                "Stihl",
                                'Gatormade',
                                'Ford'
                            ]
                        },
                        techJob: false
                    }
                ]

            }
        }
    }
</script>

<style scoped>

</style>
